export const CETELE_TEMPLATES = [
  { id: 'english_words', icon: '🧠', label: 'Kelime Ezberi', title: 'Kelime Ezberi', subject: 'İngilizce',
    description: 'Haftalık kelimeleri takip et', examples: '1. Hafta · 2. Hafta · 3. Hafta' },
  { id: 'multiplication', icon: '✖️', label: 'Çarpım Tablosu', title: 'Çarpım Tablosu', subject: 'Matematik',
    description: '2’ler, 3’ler, 6’lar...', examples: '2’ler · 3’ler · 6’lar' },
  { id: 'rhythmic_counting', icon: '🔢', label: 'Ritmik Sayma', title: 'Ritmik Sayma', subject: 'Matematik',
    description: 'İkişer, beşer, onar saymayı takip et', examples: '2’şer · 20’ye kadar / 5’er · 100’e kadar' },
  { id: 'poetry', icon: '🎤', label: 'Şiir Ezberi', title: 'Şiir Ezberi', subject: 'Türkçe',
    description: 'Her şiir için ayrı değerlendirme', examples: 'İstiklal Marşı · 23 Nisan Şiiri' },
  { id: 'letters_syllables', icon: '🔤', label: 'Harf ve Hece', title: 'Harf ve Hece', subject: 'Türkçe',
    description: 'Ses ve heceleri pekiştir', examples: 'a-n sesleri · e-t sesleri' },
  { id: 'custom', icon: '✨', label: 'Sıfırdan Oluştur', title: '', subject: '',
    description: 'Kendi başlıklarını belirle', examples: 'Öğretmenin belirlediği herhangi bir konu' },
];

export const CETELE_ICONS = Object.fromEntries(CETELE_TEMPLATES.map(t => [t.id, t.icon]));

const normalizeTitle = value => String(value || '').trim().normalize('NFC')
  .replace(/['‘’]/g, '’').replace(/\s+/g, ' ').toLocaleLowerCase('tr-TR');

const CONTROL_NAMES = {
  multiplication: ['2’ler', '3’ler', '4’ler', '5’ler', '6’lar', '7’ler', '8’ler', '9’lar', '10’lar'],
  rhythmic_counting: ['2’şer · 20’ye kadar', '5’er · 100’e kadar', '10’ar · 100’e kadar',
    '3’er · 30’a kadar', '4’er · 40’a kadar', '2’şer · 100’e kadar', '6’şar · 60’a kadar',
    '7’şer · 70’e kadar', '8’er · 80’e kadar', '9’ar · 90’a kadar'],
  poetry: ['İstiklal Marşı', '23 Nisan Şiiri', 'Atatürk Şiiri', 'Anneler Günü Şiiri'],
  letters_syllables: ['a-n sesleri', 'e-t sesleri', 'Hece birleştirme', 'Kelime okuma'],
};

export function getControlNameSuggestions(templateKey, controls = []) {
  const used = new Set(controls.map(control => normalizeTitle(control.title)));
  let candidates = Object.prototype.hasOwnProperty.call(CONTROL_NAMES, templateKey) ? CONTROL_NAMES[templateKey] : [];
  if (templateKey === 'english_words') {
    const weeks = [...used].map(title => title.match(/^(\d+)\.\s*hafta$/))
      .filter(Boolean).map(match => Number(match[1]))
      .filter(week => Number.isSafeInteger(week) && week >= 1 && week < Number.MAX_SAFE_INTEGER - 4);
    const lastWeek = weeks.reduce((last, week) => Math.max(last, week), 0);
    candidates = Array.from({ length: 4 }, (_, index) => (lastWeek + index + 1) + '. Hafta');
  }
  return candidates.filter(title => !used.has(normalizeTitle(title))).slice(0, 4);
}
